module.exports = __webpack_public_path__ + "static/cropped-c0ad713499bf58a5fe84b77046f74d10.jpg";